import { connect } from 'react-redux';
import { CartComponent } from './cart.component';

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({}); 

export const CartContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CartComponent);